import { Component, Input } from '@angular/core';
import {ParkInterface} from '@app/app/shared/interfaces/park.interface';

@Component({
  templateUrl: './park-statistic-water-consumption.html',
  selector: 'park-statistic-water-consumption'
})

export class ParkStatisticWaterConsumptionComponent {
  @Input() park: ParkInterface;
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/statistic/water-consumption/park-statistic-water-consumption.component.ts